<template>
  <div class="article-footer" :class="'align-' + textPosition">
    <div class="image-box" :class="{'loaded': imgLoaded}">
      <img :src="imgPath" alt="" @load="imgLoaded = true" lazy draggable="false" ondragstart="return false;">
    </div>
    <div class="text-box" v-if="showTextBox">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ArticleFooter",
  props: {
    image: String,
    textPosition: {
      type: String,
      default: 'bottom'
    }
  },
  data() {
    return {
      imgPath: require('../assets/images/' + this.image),
      imgLoaded: false
    }
  },
  computed: {
    showTextBox() {
      return this.$slots.default;
    }
  }
}
</script>

<style scoped>
  img {
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0;
    transition: 0.5s ease;
  }
  .loaded img {
    opacity: 1;
  }
  .article-footer:deep(p) {
    margin: 0 0 1.5em;
  }
  .article-footer:deep(h3) {
    font-size: 36px;
    line-height: 1.2;
    color: #102D61;
    margin: 0.5em -0.04em 0.8em;
  }

  @media(max-width: 999px) {
    .article-footer {
      min-height: 0;
    }
    .article-footer:deep(h3) {
      font-size: 22px;
    }
    .image-box {
      position: relative;
      display: block;
      height: 70vw;
    }
    .text-box {
      position: relative;
      padding: 15px 13px;
      font-weight: 400;
      line-height: 1.6;
      font-size: 15px;
      margin: -20px 7px 0;
      background-color: #fff;
    }
  }
  @media(max-width: 999px) and (min-width: 768px) {
    .text-box {
      margin: -20% auto 0;
      max-width: 540px;
      padding: 24px 32px 46px;
    }
  }
  @media(min-width: 1000px) {
    .article-footer {
      position: relative;
      display: flex;
      min-height: calc(20vw + 300px);
      align-items: flex-end;
      justify-content: center;
      margin-top: calc(3% + 40px);
      margin-bottom: -80px;
    }
    .article-footer.align-center {
      align-items: center;
    }
    .text-box {
      position: relative;
      width: 580px;
      padding: 34px 46px;
      background-color: #fff;
      font-weight: 400;
      color: #111C24;
      margin-left: 700px;
      margin-top: 100px;
    }
    .image-box {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
  @media(min-width: 1200px) {
    .article-footer {
      margin-bottom: -95px;
    }
  }
  @media(max-width: 1299px) and (min-width: 1000px) {
    .text-box {
      margin-left: 40vw;
      width: 52vw;
    }
  }
</style>